<template>
  <section>
    <!-- Hero -->
    <base-page-heading :title="$t('comparisionGroups.title')">
      <template #extra>
        <b-breadcrumb class="breadcrumb-alt">
          <b-breadcrumb-item>
            <router-link to="/">{{ $t("layout.breadcrumb.home") }}</router-link>
          </b-breadcrumb-item>
          <b-breadcrumb-item active
            >{{ $t("comparisionGroups.title") }}
          </b-breadcrumb-item>
        </b-breadcrumb>
      </template>
    </base-page-heading>
    <!-- END Hero -->

    <div class="content">
      <base-block title="">
        <b-row>
          <b-col>
            <b-form-group
              label-cols-sm="4"
              :label="$t('comparisionGroups.comparisionBase')"
              label-for="example-hf-email"
            >
              <select v-model="baseCompetitor" class="form-control">
                <option
                  v-for="competitor in competitors"
                  v-bind:key="competitor.competitorId"
                  v-bind:value="competitor.competitorId"
                >
                  {{ competitor.name }}
                </option>
              </select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col xl="12">
            <input
              v-model="searchInput"
              :placeholder="$t('comparisionGroups.search.placeholder')"
              class="form-control"
            />
            <br />
          </b-col>
        </b-row>
      </base-block>
      <template v-for="(mainGroup, index) in comparisonMainGroups">
        <base-block
          :title="mainGroup.name"
          v-bind:key="index"
          class="comparison-main-group"
          v-if="
            searchInput == '' ||
              mainGroup.name
                .toLowerCase()
                .indexOf(searchInput.toLowerCase()) !== -1
          "
        >
          <b-table-simple
            responsive
            bordered
            striped
            table-class="table-vcenter"
            :id="'table' + index"
          >
            <b-thead>
              <b-tr>
                <b-th class="text-center">
                  {{ $t("comparisionGroups.brand") }}
                </b-th>
                <b-th
                  colspan="2"
                  v-for="(comparisonGroup, groupIndex) in mainGroup.subGroups"
                  v-bind:key="groupIndex"
                  v-bind:value="groupIndex"
                  class="comparison-group"
                  :data-group-id="comparisonGroup.comparisonGroupId"
                >
                  <router-link
                    :to="'/report?group=' + comparisonGroup.comparisonGroupId"
                  >
                    {{ comparisonGroup.shortName }}
                  </router-link>
                </b-th>
              </b-tr>
              <b-tr>
                <b-th></b-th>
                <b-th
                  colspan="2"
                  v-for="(comparisonGroup, groupIndex) in mainGroup.subGroups"
                  v-bind:key="groupIndex"
                  v-bind:value="groupIndex"
                  class="comparison-group"
                  :data-group-id="comparisonGroup.comparisonGroupId"
                >
                  <router-link
                    :to="'/report?group=' + comparisonGroup.comparisonGroupId"
                  >
                    <img
                      :src="comparisonGroup.refImage"
                      alt=""
                      v-if="comparisonGroup.refImage != ''"
                      class="item-img"
                    />
                  </router-link>
                </b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr
                v-for="competitor in competitors"
                v-bind:key="competitor.competitorId"
                v-bind:value="competitor.competitorId"
              >
                <b-td
                  :class="{
                    'text-bold': baseCompetitor == competitor.competitorId
                  }"
                >
                  {{ competitor.name }}
                </b-td>
                <template
                  v-for="(comparisonGroup, groupIndex) in mainGroup.subGroups"
                >
                  <td
                    v-bind:key="groupIndex"
                    class="font-size-sm text-right"
                    :data-num-fmt="$n(0.0, 'currency')"
                  >
                    <span
                      v-if="
                        comparisonGroupItems[
                          comparisonGroup.comparisonGroupId
                        ] &&
                          comparisonGroupItems[
                            comparisonGroup.comparisonGroupId
                          ][competitor.competitorId]
                      "
                      :class="{
                        'text-bold': baseCompetitor == competitor.competitorId
                      }"
                    >
                      <template v-if="excelExport">
                        {{
                          comparisonGroupItems[
                            comparisonGroup.comparisonGroupId
                          ][competitor.competitorId].price
                        }}
                      </template>
                      <template v-else>
                        {{
                          $n(
                            comparisonGroupItems[
                              comparisonGroup.comparisonGroupId
                            ][competitor.competitorId].price,
                            "currency"
                          )
                        }}
                      </template>
                    </span>
                  </td>
                  <td
                    v-bind:key="groupIndex + 'se'"
                    class="font-size-sm text-right"
                    data-num-fmt="0.0%"
                  >
                    <span
                      v-if="
                        comparisonGroupItems[
                          comparisonGroup.comparisonGroupId
                        ] &&
                          comparisonGroupItems[
                            comparisonGroup.comparisonGroupId
                          ][competitor.competitorId] &&
                          comparisonGroupItems[
                            comparisonGroup.comparisonGroupId
                          ][baseCompetitor] &&
                          comparisonGroupItems[
                            comparisonGroup.comparisonGroupId
                          ][baseCompetitor].price > 0
                      "
                      :class="{
                        'text-green':
                          (1 /
                            comparisonGroupItems[
                              comparisonGroup.comparisonGroupId
                            ][baseCompetitor].price) *
                            comparisonGroupItems[
                              comparisonGroup.comparisonGroupId
                            ][competitor.competitorId].price -
                            1 >
                          0,
                        'text-red':
                          (1 /
                            comparisonGroupItems[
                              comparisonGroup.comparisonGroupId
                            ][baseCompetitor].price) *
                            comparisonGroupItems[
                              comparisonGroup.comparisonGroupId
                            ][competitor.competitorId].price -
                            1 <
                          0,
                        'text-bold': baseCompetitor == competitor.competitorId
                      }"
                    >
                      {{
                        $n(
                          (1 /
                            comparisonGroupItems[
                              comparisonGroup.comparisonGroupId
                            ][baseCompetitor].price) *
                            comparisonGroupItems[
                              comparisonGroup.comparisonGroupId
                            ][competitor.competitorId].price -
                            1,
                          "percent"
                        )
                      }}
                    </span>
                  </td>
                </template>
              </b-tr>
            </b-tbody>
          </b-table-simple>
          <b-button
            class="btn-block"
            @click="exportToExcel(mainGroup.name, 'table' + index)"
            >{{ $t("comparisionGroups.excelExport") }}
          </b-button>
        </base-block>
      </template>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import ComparisonMainGroups from "@/assets/js/ComparisonMainGroups";
import Items from "@/assets/js/ComparisonGroups/Items";
import Competitors from "@/assets/js/Competitors";
import Loading from "@/store/loading";
import XLSX from "xlsx";

export default {
  name: "ComparisonGroups",
  components: {},
  data() {
    return {
      comparisonMainGroups: [],
      comparisonGroupItems: [],
      competitors: [],
      baseCompetitor: 1,
      observer: {},
      searchInput: "",
      excelExport: false
    };
  },
  mounted() {
    document.title = this.$t("comparisionGroups.title");

    Loading.dispatch("increase", 2);
    this.$store.commit("pageLoader", { mode: "on" });

    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          let groupId = entry.target.getAttribute("data-group-id");
          this.getComparisonGroupItems(groupId);
        }
      });
    });

    ComparisonMainGroups.getListWithSubGroups().then(comparisonMainGroups => {
      this.$set(this, "comparisonMainGroups", comparisonMainGroups);
      Loading.dispatch("reduce");
    });
    Competitors.get().then(competitors => {
      this.$set(this, "competitors", competitors);
      Loading.dispatch("reduce");
    });
  },
  updated() {
    document.getElementsByClassName("comparison-group").forEach(entry => {
      this.observer.observe(entry);
    });
  },
  methods: {
    getComparisonGroupItems: function(groupId) {
      if (typeof this.comparisonGroupItems[groupId] == "undefined") {
        Items.get(groupId).then(items => {
          this.$set(this.comparisonGroupItems, groupId, items);
        });
      }
    },
    exportToExcel: function(groupName, tableNodeId) {
      this.excelExport = true;
      let vueComponent = this;

      setTimeout(function() {
        let dataWorksheet = XLSX.utils.table_to_sheet(
          document.getElementById(tableNodeId)
        );

        dataWorksheet["!autofilter"] = { ref: "A1:I1" };

        let workBook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
          workBook,
          dataWorksheet,
          groupName.substring(0, 30)
        );

        XLSX.writeFile(workBook, groupName + ".xlsx");

        vueComponent.excelExport = false;
      }, 200);
    }
  }
};
</script>

<style lang="scss" scoped>
#app {
  .item-img {
    max-width: 10em;
    height: auto;
  }
}
</style>
